import {Injectable, ViewContainerRef} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import {Questions} from "../../classes/question";

@Injectable()
export class RepeaterFormOpenService {



  private repeater_parent : number;

  private subject: Subject<number> = new Subject<number>();

  setRepeaterParent(repeater_parent: number): void {
    this.repeater_parent = repeater_parent;
    this.subject.next(repeater_parent);
  }

  getRepeaterParent(): Observable<number> {
    return this.subject.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/repeater-form-open.service.ts